/**
 * @generated SignedSource<<fb2300e7704be505810830b94a0c45f9>>
 * @relayHash 529cad23f4ba104eb71ed003fb84403b
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 529cad23f4ba104eb71ed003fb84403b

import { ConcreteRequest } from 'relay-runtime';
export type LoopNavProviderContainerQuery$variables = {
  nodeId: string;
};
export type LoopNavProviderContainerQuery$data = {
  readonly node: {
    readonly __typename: string;
    readonly loopNav?: {
      readonly items: ReadonlyArray<{
        readonly items: ReadonlyArray<{
          readonly listItemResourceId: string | null;
          readonly permalink: string | null;
          readonly text: string;
        }>;
        readonly listItemResourceId: string | null;
        readonly permalink: string | null;
        readonly text: string;
      }>;
      readonly title: string;
    } | null;
    readonly path?: string;
  };
};
export type LoopNavProviderContainerQuery = {
  response: LoopNavProviderContainerQuery$data;
  variables: LoopNavProviderContainerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "nodeId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "nodeId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "listItemResourceId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "permalink",
  "storageKey": null
},
v8 = [
  (v3/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "LoopNavResourceType",
    "kind": "LinkedField",
    "name": "loopNav",
    "plural": false,
    "selections": [
      (v4/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "LoopNavListItemType",
        "kind": "LinkedField",
        "name": "items",
        "plural": true,
        "selections": [
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "LoopNavListItemType",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v5/*:: as any*/),
              (v7/*:: as any*/),
              (v6/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = [
  (v3/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "LoopNavResourceType",
    "kind": "LinkedField",
    "name": "loopNav",
    "plural": false,
    "selections": [
      (v4/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "LoopNavListItemType",
        "kind": "LinkedField",
        "name": "items",
        "plural": true,
        "selections": [
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "LoopNavListItemType",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v5/*:: as any*/),
              (v7/*:: as any*/),
              (v6/*:: as any*/),
              (v9/*:: as any*/)
            ],
            "storageKey": null
          },
          (v9/*:: as any*/)
        ],
        "storageKey": null
      },
      (v9/*:: as any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LoopNavProviderContainerQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*:: as any*/),
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            {
              "kind": "InlineFragment",
              "selections": (v8/*:: as any*/),
              "type": "FeedContentResourceInterface",
              "abstractKey": "__isFeedContentResourceInterface"
            },
            {
              "kind": "InlineFragment",
              "selections": (v8/*:: as any*/),
              "type": "CategoryResourceType",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v8/*:: as any*/),
              "type": "VideoGameResourceType",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "LoopNavProviderContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": (v10/*:: as any*/),
            "type": "FeedContentResourceInterface",
            "abstractKey": "__isFeedContentResourceInterface"
          },
          {
            "kind": "InlineFragment",
            "selections": (v10/*:: as any*/),
            "type": "CategoryResourceType",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v10/*:: as any*/),
            "type": "VideoGameResourceType",
            "abstractKey": null
          },
          (v9/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "529cad23f4ba104eb71ed003fb84403b",
    "metadata": {},
    "name": "LoopNavProviderContainerQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4c3e8c249bd5b267f0ed4e22d21e8d9d";

export default node;
